import MicroModal from '../micromodal.min.js';

export default function () {
    const widgetName = 'cardWidgetHomepagePopup';
    const widgetOpts = cardWidgetHomepagePopupOpts;
  
    return saffire.widgets.cardWidget($(`#${widgetName}`), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      buyNowButton: {
        visible: false,
        text: 'BUY NOW'
      },
  
      cardWidgetLoaded: function (data, owl, hasData) {
        const d = data.items[0];
        const title = d.Title;
        const description = d.Description;
        const url = d.URL;
        const img = d.ImageWithPath;

        function initializePopupModal() {
          $('body').append(`
          <div class="micromodal-slide" id="modal" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
              <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                <span class="modal-close-btn" data-micromodal-close>Close X</span>
                <div class="modal__content" id="modal-content">
                  <div class="modal__content-left">
                    <a href="${img}" aria-label="afterparty flyer" target="_blank">
                        <img src="${img}" alt="afterparty flyer">
                    </a>  
                  </div>
                  <div class="modal__content-right">
                    <h2 class="modal__title" id="modal-title">
                      ${title}
                    </h2>
                    <div class="modal__description">${description}</div>
                    <a href="javascript:void(0);" data-micromodal-close class="modal__button button">Close</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          `);

          MicroModal.init();
          MicroModal.show('modal');
        }

        if (hasData) {
          if (navigator.cookieEnabled && $('#modal') && $('body').hasClass('homepage')) {
            if (Cookies.get('modalCookie')) {
              return false;
            } else {
              Cookies.set('modalCookie', 'modalCookie', { expires: 1 });
              initializePopupModal();
            }
          }  
        }
      },
      itemsPerPanel: 1,
      hasImages: true,
      lazyLoadImages: true,
      imageIsBackground: false,
      link: [], // [], ['all'], ['image', 'title', 'description']
      maxItemsVisible: 1,
      moreButton: {
        visible: false,
        text: 'MORE'
      },
      scriptPath: widgetOpts.scriptPath,
      showDescription: true,
      slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
      slideshowOptions: {
        items: 1,
        loop: true,
        margin: 10,
        navText: ['Prev', 'Next'],
        nav: true
      },
      textOverImage: false
    });
  
  }
